export * from './displayid.directive';
export * from './displayid.module';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/displayid/index.ts